import React from 'react'

import { updateTheme } from '@/utils/utils'

export type ThemeMode = 'light' | 'dark'

type ThemeContextValue = {
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
}

const ThemeContext = React.createContext<ThemeContextValue | null>(null)

const readStoredMode = (): ThemeMode => (localStorage.getItem('theme') === 'light' ? 'light' : 'dark')

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [mode, setModeState] = React.useState<ThemeMode>(readStoredMode)

  React.useEffect(() => {
    updateTheme(mode === 'light')
  }, [mode])

  const setMode = React.useCallback((next: ThemeMode) => setModeState(next), [])

  const value = React.useMemo(() => ({ mode, setMode }), [mode, setMode])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export const useTheme = (): ThemeContextValue => {
  const context = React.useContext(ThemeContext)

  if (!context) throw new Error('useTheme musi być użyte wewnątrz ThemeProvider')

  return context
}
